import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent } from '../../models/base/base.component';
import { UserRole } from '../../models/enums';
import { LookupService } from '../../services/lookup.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'user-detail',
  templateUrl: './user-detail.component.html',
  providers: [LookupService]
})
export class UserDetailComponent extends BaseComponent implements OnInit {
  @Input() model: any = null;
  @Input() showModal: boolean = true;

  isAdmin: boolean = false;
  userRole: number = 0;
  showNotesAdd: boolean = false;
  lookups: any = {};
  metadata: any = {};
  phones = [];
  cargoLimit = [];
  cargoInsurance = [];

  UserRole = UserRole;

  constructor(
    private lookupService: LookupService,
    private navigationService: NavigationService) {
    super();
  }

  ngOnInit() {
    this.isAdmin = !!localStorage.getItem('isAdmin');
    this.userRole = +localStorage.getItem('userRole');

    this.loadLookup('yesNoNa');
    this.loadLookup('yesNoNaNull');
    this.loadLookup('yesNo');
    this.loadLookup('yesNoNull');

    this.setPermissions();

    this.phones = this.getStringArray(this.model.additionalPhones, ';');
    this.cargoLimit = this.getStringArray(this.model.cargoInsuranceLimit, ';');
    this.cargoInsurance = this.getStringArray(this.model.cargoInsuranceDeductible, ';');

    if (this.model != null) {
      this.metadata = this.model.metadata;
    }

  }


  loadLookup(key: string, force: boolean = false) {
    this.lookupService.get(key, force)
      .subscribe(r => {
        this.lookups[key] = r;
      });
  }

  close() {
    this.navigationService.showDetail(false);
  }

  setPermissions() {
    if (this.userRole == 3 || this.isAdmin) {
      this.showNotesAdd = true;
    }
  }

}
